import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-is-no-paid-order-pop-up',
  templateUrl: './is-no-paid-order-pop-up.component.html',
  styleUrls: ['./is-no-paid-order-pop-up.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-20px)', opacity: 0 }),
        animate('400ms cubic-bezier(0.35, 0, 0.25, 1)', 
          style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', 
          style({ transform: 'translateY(-20px)', opacity: 0 }))
      ])
    ])
  ]
})
export class IsNoPaidOrderPopUpComponent implements OnDestroy {
  private routerSub: Subscription;

  constructor(
    public dialogRef: MatDialogRef<IsNoPaidOrderPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { msg: string },
    private router: Router
  ) {
    // Close dialog on route change (e.g., nav bar click)
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialogRef.close();
      }
    });

    // Prevent dialog from closing on backdrop click (we'll handle it ourselves)
    this.dialogRef.disableClose = true;
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  // Close dialog only when clicking on the outermost container
  onDialogClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // Only close if clicking on the outermost container
    if (target.classList.contains('popup-overlay')) {
      this.onCancel();
    }
  }
}
